module.exports = __webpack_public_path__ + "img/factory-icon-2.fa206986.svg";